<template>
  <div class="p-post-image">
    <CommonHeader>
      {{ $t('feed.name') }}
      <template slot="left">
        <a v-if="step === 1" @click.prevent="cancel">取消</a>
        <svg
          v-else
          class="m-style-svg m-svg-def"
          @click="preStep"
        >
          <use xlink:href="#icon-back" />
        </svg>
      </template>
      <template slot="right">
        <a
          v-if="step !== 2"
          :class="{ disabled }"
          class="m-send-btn"
          @click.prevent="nextStep"
        >下一步</a>
        <span
          v-if="step === 2"
          class="m-send-btn"
          @click="beforePost"
        >发布</span>
      </template>
    </CommonHeader>

    <TransitionGroup
      :enter-active-class="animated.enterClass"
      :leave-active-class="animated.leaveClass"
      tag="main"
      class="m-box-model m-flex-grow1 m-flex-shrink1 p-post-image-main"
    >
      <div v-show="step === 1" key="step1">
        <div class="content-wrap">
          <TextareaInput
            ref="textarea"
            v-model="contentText"
            maxlength="1000"
            warnlength="800"
            :placeholder="$t('release.image_placeholder')"
            @onBlur="moveCurPos"
            @onInput="moveCurPos"
          />
          <!-- <textarea
            ref="textarea"
            v-model.trim="contentText"
            :rows="2"
            maxlength="100"
            :placeholder="$t('release.image_placeholder')"
            @blur="moveCurPos"
            @input="moveCurPos"
          /> -->
          <!-- <TextareaInput
            v-model="contentText"
            :rows="11"
            ref="textarea"
            :maxlength="255"
            :warnlength="200"
            :placeholder="$t('release.image_placeholder')"
          /> -->
        </div>

        <ImageList :edit="pinned" style="padding: 0 .2rem .2rem" />
      </div>
      <div
        v-show="step === 2"
        key="step2"
        class="m-pos-f m-box-model m-flex-grow1 next-main"
      >
        <FormTagsBreakLine
          v-model="tags"
          class="select-tags"
          :max="3"
          :label="$t('tags.select')"
          :placeholder="$t('tags.select')"
        />

        <div class="m-box-model m-attach">
          <div class="m-box m-justify-bet">
            <span class="m-attach-label">{{ $t('release.upload_attachment') }}</span>
            <input
              v-if="inputShow"
              ref="imagefile"
              type="file"
              class="m-rfile"
              @change="onBannerChange"
            >
            <div class="m-flex-grow1 m-flex-shrink1 m-text-r" @click="uploadAttachments">
              <button class="m-attach-btn">{{ $t('release.upload_attachment') }}</button>
              <!-- <div class="m-box m-justify-end"></div> -->
            </div>
          </div>
          <!-- attach list start -->
          <div
            v-for="attachment in attachments"
            :key="attachment.id"
            class="m-attach-files"
          >
            <div class="m-attach__file m-box" @click="$download(attachment, 'show')">
              <attachment-type :name="attachment.file.name" />
              <span class="m-attach__filename">{{ attachment.file.name }}</span>
              <img src="@/images/delete.png" @click.stop="deleteAttachments(attachment)">
            </div>
          </div>
          <!-- attach list end -->
        </div>
      </div>
    </TransitionGroup>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { mapGetters } from 'vuex'
  import sendImage from '@/util/SendImage.js'
  import * as api from '@/api/question/answer'
  import ImageList from './components/ImageList'
  import TextareaInput from '@/components/common/TextareaInput.vue'
  import AttachmentType from '@/components/common/AttachmentType.vue'

  export default {
    name: 'PostImage',
    components: { ImageList, AttachmentType, TextareaInput },
    data () {
      return {
        step: 1,
        curpos: 0,
        pinned: false,
        loading: false,
        animated: {},
        contentText: '',
        tags: [],
        members: [],
        attachments: [],
        inputShow: true,
        showReward: false,
      }
    },
    computed: {
      ...mapGetters(['composePhoto']),
      disabled () {
        return !this.contentText
      },
    },
    watch: {
      step (val) {
        val === 2 &&
          this.$nextTick(() => {
            if (this.$refs.editor) {
              this.$refs.editor.innerHTML = this.contentText
            }
          })
      },
    },
    methods: {
      getAvatar (avatar) {
        avatar = avatar || {}
        return avatar.url || null
      },
      preStep () {
        if (this.step <= 1) return
        this.animated = {
          enterClass: 'animated slideInLeft',
          leaveClass: 'animated slideOutRight',
        }
        this.step -= 1
      },
      nextStep () {
        if (this.disabled) return
        if (this.composePhoto.length && this.composePhoto.some(item => !item.id)) {
          this.$Message.error('附件上传中，请稍等~~~')
          return
        }
        if (this.step < 2) {
          this.animated = {
            enterClass: 'animated slideInRight',
            leaveClass: 'animated slideOutLeft',
          }
          this.step += 1
        }
      },
      beforePost () {
        const { contentText, attachments = [], members } = this
        if (!contentText) {
          return (this.step = 2) && this.$Message.error('请输入分享内容')
        }
        const body = contentText.replace(/(@\S*)\s/g, '\u00ad$1\u00ad ')
        this.postAnswer({
          feed_from: 2,
          feed_content: body,
          images: this.composePhoto,
          attachments: attachments.map(item => item.id),
          feed_mark: new Date().valueOf() + '' + this.$store.state.CURRENTUSER.id,
          tags: this.tags,
        })
      },
      postAnswer (params) {
        if (this.loading) return
        this.loading = true
        this.$http
          .post('feeds', { ...params }, { validateStatus: s => s === 201 })
          .then(() => {
            this.$Message.success(this.$t('release.success'))
            this.$router.replace('/shares?type=new&refresh=1')
          })
          .catch(err => {
            this.$Message.error(err.response.data)
          })
          .finally(() => {
            this.loading = false
          })
      },
      cancel () {
        const quit = () => {
          this.goBack()
          this.$destroy()
        }
        const actions = [
          { style: { color: '#f4504d' }, text: '放弃', method: quit },
        ]
        this.$bus.$emit(
          'actionSheet',
          actions,
          '取消',
          '你还有未发布的内容，是否放弃发布？'
        )
      },
      uploadAttachments () {
        if (!this.inputShow) {
          return this.$Message.error('上传中...')
        }
        this.$refs.imagefile.click()
      },
      async onBannerChange () {
        const $input = this.$refs.imagefile
        const file = $input.files[0]
        // 上传图片
        this.inputShow = false
        let id
        try {
          id = await sendImage(file)
        } catch (error) {}
        this.inputShow = true
        this.attachments.push({ id, file })
      },
      deleteAttachments ({ id }) {
        this.attachments = this.attachments.filter(item => item.id !== id)
      },
      moveCurPos (event) {
        this.$refs.textarea && (this.curpos = this.$refs.textarea.$refs.textarea.selectionStart)

        if (event.data === '@') {
          this.$bus.$emit('at', {
            callback: (username) => {
              const regex = RegExp(`(.{${this.curpos}})`)
              this.contentText = this.contentText.replace(regex, `$1${username} `)
              this.$nextTick(() => {
                this.$refs.textarea && this.$refs.textarea.focus()
              })
            },
          })
        }
      },
    },
  }
</script>

<style lang="less" scoped>
.p-post-image-main {
  display: flex;
  flex-direction: column;
  background-color: @body-bg;
  min-height: 90vh;
  > div {
    animation-duration: 0.3s;
  }
  .m-pos-f {
    // top: 90px;
    position: relative;
    margin: 0;
  }
  .content-wrap {
    position: relative;
    width: 100%;
    height: calc(~'100% + 40px');
    margin-top: 15px;
    padding: 0 20px;
    textarea {
      width: 100%;
      min-height: 400px;
      word-wrap: break-word;
      word-break: break-all;
      font-size: inherit;
      text-align: inherit;
      line-height: inherit;
    }
  }
  .next-main {
    background-color: #f7f7f7;
    .select-tags {
      margin-top: 30px;
    }
  }
  .m-attach {
    margin-top: 30px;
    padding: 26px 20px;
    background-color: white;
    border-bottom: 1px solid @border-color;
    &-label {
      flex: none;
      align-self: flex-start;
      width: 150px;
    }
    &-btn {
      height: 50px;
      color: #fff;
      font-size: 24px;
      background-color: #00aeef;
      border-radius: 25px;
      padding: 8px 30px;
    }
    &-files {
      width: 100%;
    }
    &__file {
      flex-basis: 100%;
      margin-top: 20px;
      img {
        margin-left: 20px;
        width: 32px;
        height: 32px;
      }
    }
    &__filename {
      display: inline-block;
      font-size: 28px;
      margin-left: 20px;
      flex-grow: 1;
      word-break: break-all;
    }
  }
}
</style>
